module.exports = __webpack_public_path__ + "img/7spades.203d5ce5.jpg";